<template>
  <div class="pagination">
    <button 
      @click="$emit('page-change', currentPage - 1)" 
      :disabled="currentPage === 1"
      class="page-btn"
    >
      ‹ Previous
    </button>
    
    <span class="page-info">
      Page {{ currentPage }} of {{ totalPages }}
    </span>
    
    <button 
      @click="$emit('page-change', currentPage + 1)" 
      :disabled="currentPage === totalPages"
      class="page-btn"
    >
      Next ›
    </button>
  </div>
</template>

<script setup>
import { COLORS } from '@/styles/brand'

defineProps({
  currentPage: {
    type: Number,
    required: true
  },
  totalPages: {
    type: Number,
    required: true
  }
})

defineEmits(['page-change'])
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 20px;
  position: relative;
  z-index: 1;
}

.page-btn {
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.page-btn:hover:not(:disabled) {
  background: v-bind('COLORS.PRIMARY.RED');
  border-color: v-bind('COLORS.PRIMARY.RED');
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  color: white;
  font-weight: 500;
}
</style>